import type {
  AdminCrewReportBulkRequestItem,
  AdminCrewReportBulkRequestItemStatus,
  AdminCrewReportRequestLifecycleStatus,
  AdminCrewReportRequestResponse,
} from "../models/admin-crew-report.models";
import { ADMIN_CREW_REPORT_REQUEST_STATUS_LABELS } from "./admin-crew-report.constants";

export function updateAdminCrewReportBulkRequestItem(
  items: AdminCrewReportBulkRequestItem[],
  imoNumber: string,
  updates: Partial<Omit<AdminCrewReportBulkRequestItem, "vessel">>,
): AdminCrewReportBulkRequestItem[] {
  return items.map((item) => (item.vessel.imoNumber === imoNumber ? { ...item, ...updates } : item));
}

export function getAdminCrewReportBulkRequestOutcome(response: AdminCrewReportRequestResponse): {
  status: Extract<AdminCrewReportBulkRequestItemStatus, "sent" | "unconfirmed" | "pending">;
  lifecycleStatus: AdminCrewReportRequestLifecycleStatus;
} {
  if (response.requestStatusRecorded === false) {
    return { status: "pending", lifecycleStatus: "PENDING" };
  }

  if (response.emailDeliveryConfirmed === false) {
    return { status: "unconfirmed", lifecycleStatus: "DELIVERY_UNCONFIRMED" };
  }

  return { status: "sent", lifecycleStatus: "SENT" };
}

export function getAdminCrewReportBulkRequestStatusLabel(status: AdminCrewReportBulkRequestItemStatus): string {
  switch (status) {
    case "resolvingRecipient":
      return "Resolving recipient";
    case "sendingRequest":
      return "Sending request";
    case "sent":
      return ADMIN_CREW_REPORT_REQUEST_STATUS_LABELS.SENT;
    case "unconfirmed":
      return ADMIN_CREW_REPORT_REQUEST_STATUS_LABELS.DELIVERY_UNCONFIRMED;
    case "pending":
      return ADMIN_CREW_REPORT_REQUEST_STATUS_LABELS.PENDING;
    case "failed":
      return "Failed";
  }
}
